module.exports = __webpack_public_path__ + "img/SCHEME_MOBILE_EN.15fc04b2.svg";